module.exports = __webpack_public_path__ + "static/media/ckn_restaurante_categoria_nuevo.bfe3d873.jpg";